<app-header></app-header>
<div class="page-content">
    <h1 class="webapp-title">
        Disponible en breve
    </h1>
</div>
<app-footer></app-footer>
